export default __webpack_public_path__ + "assets/front/scss/common.a6ee6d844a3f88de6bf684ac809d196a.css";